module.exports = __webpack_public_path__ + "assets/img/certification1.39ced477.svg";